import script from "./ColdRoomRunTime.vue?vue&type=script&setup=true&lang=js"
export * from "./ColdRoomRunTime.vue?vue&type=script&setup=true&lang=js"

import "./ColdRoomRunTime.vue?vue&type=style&index=0&id=46ae1013&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ae1013"]])

export default __exports__